'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

require('regenerator-runtime/runtime');

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

var _ngFileUpload = require('ng-file-upload');

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

var _getTextractScoresheets = require('ifeis-isomorphic/lib/redux/actions/textract/getTextractScoresheets');

var _saveTextractData = require('ifeis-isomorphic/lib/redux/actions/textract/saveTextractData');

var _getFeisAdjudicators = require('ifeis-isomorphic/lib/redux/actions/adjudicators/getFeisAdjudicators');

var _getFeisAdjudicators2 = _interopRequireDefault(_getFeisAdjudicators);

var _getEvents = require('ifeis-isomorphic/lib/redux/actions/events/getEvents');

var _getEvents2 = _interopRequireDefault(_getEvents);

var _events = require('ifeis-isomorphic/lib/utilities/events');

var _textractStatuses = require('ifeis-isomorphic/lib/utilities/textract-statuses');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var TextractController = function () {
  function TextractController($ngRedux, $q, $scope, feis, $state, $mdDialog, $mdMedia, msgService, fPrompt, fFeisService, Upload) {
    var _this = this;

    _classCallCheck(this, TextractController);

    this._ = {
      $ngRedux: $ngRedux,
      $q: $q,
      $scope: $scope,
      $state: $state,
      $mdDialog: $mdDialog,
      $mdMedia: $mdMedia,
      msgService: msgService,
      fPrompt: fPrompt,
      fFeisService: fFeisService,
      Upload: Upload
    };

    this.isLoading = true;
    this.feis = feis;
    this.adjudicatorList = [];
    this.eventList = [];
    this.scorepdfs = [];
    this.approvedPdfs = [];
    this._getDescription = _events.getDescription;

    this._.$q.all([this._.$ngRedux.dispatch((0, _getFeisAdjudicators2.default)(this.feis.id)), this._.$ngRedux.dispatch((0, _getTextractScoresheets.getTextractScoresheetPdfs)(this.feis.id, [_textractStatuses.textractStatus.PENDING, _textractStatuses.textractStatus.ERROR])), this._.$ngRedux.dispatch((0, _getEvents2.default)(this.feis.id, false, true, 'CLOSED_NOT_APPROVED'))]).then(function (res) {
      _this.isLoading = false;
      _this.adjudicatorList = res[0].payload;
      _this.scorepdfs = res[1].payload;
      _this.eventList = res[2].payload;
    }).catch(function (err) {
      _this.isLoading = false;
      _this._.msgService.displayErrorMsg('Error getting textract records' + err);
    });

    this._.$scope.$watch(function () {
      return _this.fileToUpload;
    }, function (file) {
      if (!file) return;

      if (!_this.adjudicatorList || _this.adjudicatorList.length === 0) {
        _this._.msgService.displayErrorMsg('No associated judges found. Please associate judges first.');
      }if (!file.name || !file.name.endsWith('.pdf')) {
        _this._.msgService.displayErrorMsg('Only pdf files are accepted. Please select a pdf file to upload.');
      }if (!_this.eventList || _this.eventList.length === 0) {
        _this._.msgService.displayErrorMsg('No qualifying events. Please check the events state.');
      } else {
        _this._.$mdDialog.show({
          controller: function controller($scope, locals) {
            $scope.adjudicators = locals.adjudicators;
            $scope.events = locals.events;
            $scope.recordToUpload = {
              name: file.name,
              aid: _this.adjudicatorList[0].id,
              eventId: _this.eventList[0].id
            };
            $scope.cancel = function () {
              return _this._.$mdDialog.cancel();
            };
            $scope.create = function (recordToUpload) {
              return _this._.$mdDialog.hide(recordToUpload);
            };
          },
          template: require('./uploadPdf.tmpl.html'),
          parent: angular.element(document.body),
          clickOutsideToClose: true,
          fullscreen: _this._.$mdMedia('md'),
          locals: {
            adjudicators: _this.adjudicatorList,
            events: _this.eventList
          }
        }).then(function (_ref) {
          var name = _ref.name,
              aid = _ref.aid,
              eventId = _ref.eventId;

          var selectedAdjudicator = _this.adjudicatorList.find(function (adj) {
            return adj.id === aid;
          });
          var selectedEvent = _this.eventList.find(function (ev) {
            return ev.id === eventId;
          });
          _this.isLoading = true;
          return _this._.fFeisService.createScoresheetPdf(Upload, _this.feis.id, file, name, aid, selectedEvent.id).then(function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(response) {
              var pdfResponse;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      if (!(response.length === 0)) {
                        _context.next = 5;
                        break;
                      }

                      _this.isLoading = false;
                      _this._.msgService.displayErrorMsg('Please check to make sure the event name in the pdf is clear and belongs to the feis that you are trying to upload.');
                      _context.next = 11;
                      break;

                    case 5:
                      _context.next = 7;
                      return _this._.$ngRedux.dispatch((0, _getTextractScoresheets.getTextractScoresheetPdfs)(_this.feis.id, [_textractStatuses.textractStatus.PENDING, _textractStatuses.textractStatus.ERROR]));

                    case 7:
                      pdfResponse = _context.sent;

                      _this.scorepdfs = pdfResponse.payload;
                      _this.isLoading = false;
                      _this._.msgService.displaySuccessMsg('New textract record added.');

                    case 11:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, _this);
            }));

            return function (_x) {
              return _ref2.apply(this, arguments);
            };
          }()).catch(function (err) {
            _this.isLoading = false;
            _this._.msgService.displayErrorMsg('Could not upload file. Error is ' + err + '. Please try again or manually enter score sheet.');
          });
        }).catch(function (err) {
          _this.isLoading = false;
          _this._.msgService.displaySuccessMsg('Upload process cancelled.');
        });
      }
    });
  }

  _createClass(TextractController, [{
    key: 'getApprovedTextractPdfs',
    value: function getApprovedTextractPdfs() {
      var _this2 = this;

      this._.$ngRedux.dispatch((0, _getTextractScoresheets.getTextractScoresheetPdfs)(this.feis.id, [_textractStatuses.textractStatus.APPROVED])).then(function (res) {
        return _this2.approvedPdfs = res.payload;
      });
    }
  }, {
    key: 'deleteTextractRecord',
    value: function deleteTextractRecord(pdfDetail) {
      var _this3 = this;

      var confirm = this._.$mdDialog.confirm().title('Delete Textract Record?').textContent('You are about to delete the pdf and textract record.  Are you sure?').cancel('Cancel').ok('Delete');

      return this._.$mdDialog.show(confirm).then(function () {
        _this3.isLoading = true;
        return _this3._.$ngRedux.dispatch((0, _saveTextractData.deleteTextract)(pdfDetail.textract.id, _this3.feis.id, pdfDetail.textract.pdfName)).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var pdfResponse;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _context2.next = 2;
                  return _this3._.$ngRedux.dispatch((0, _getTextractScoresheets.getTextractScoresheetPdfs)(_this3.feis.id, [_textractStatuses.textractStatus.PENDING, _textractStatuses.textractStatus.ERROR]));

                case 2:
                  pdfResponse = _context2.sent;

                  _this3.scorepdfs = pdfResponse.payload;
                  _this3.isLoading = false;
                  _this3._.msgService.displaySuccessMsg('Textract record deleted.');

                case 6:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this3);
        }))).catch(function (err) {
          _this3.isLoading = false;
          _this3._.msgService.displayErrorMsg(err);
        });
      });
    }
  }, {
    key: 'uploadScores',
    value: function uploadScores(pdfDetail) {
      var _this4 = this;

      var confirm = this._.$mdDialog.confirm().title('Upload score sheet?').textContent('You are about to start the score sheet upload process. Please click continue if you are sure.').cancel('Cancel').ok('Continue');
      if (pdfDetail.event.is_in_tabs === 1 || pdfDetail.event.is_in_results === 1 || pdfDetail.event.is_in_qa === 1) {
        confirm = this._.$mdDialog.confirm().title('Event already has scores').textContent('Event is already in TABS status or beyond. Do you want to re-upload?').cancel('Cancel').ok('Continue');
      }
      return this._.$mdDialog.show(confirm).then(function () {
        _this4.extractScoresheetScoresAndCreateQAScores(pdfDetail);
      });
    }
  }, {
    key: 'approveScoreSheet',
    value: function approveScoreSheet(pdfDetail) {
      var _this5 = this;

      var confirm = this._.$mdDialog.confirm().title('Manually approve score sheet?').textContent('You are about to approve this score sheet. Once complete, this will appear in the next tab. Please click Ok to continue.').cancel('Cancel').ok('Ok');

      return this._.$mdDialog.show(confirm).then(function () {
        _this5.isLoading = true;
        return _this5._.$ngRedux.dispatch((0, _saveTextractData.updateTextract)(pdfDetail.textract.id, _this5.feis.id, pdfDetail.textract.confidenceScore, pdfDetail.textract.errorText, _textractStatuses.textractStatus.APPROVED)).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
          var pdfResponse;
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _context3.next = 2;
                  return _this5._.$ngRedux.dispatch((0, _getTextractScoresheets.getTextractScoresheetPdfs)(_this5.feis.id, [_textractStatuses.textractStatus.PENDING, _textractStatuses.textractStatus.ERROR]));

                case 2:
                  pdfResponse = _context3.sent;

                  _this5.scorepdfs = pdfResponse.payload;
                  _this5.isLoading = false;
                  _this5._.msgService.displaySuccessMsg('Textract record approved and moved to textract images tab.');

                case 6:
                case 'end':
                  return _context3.stop();
              }
            }
          }, _callee3, _this5);
        }))).catch(function (err) {
          _this5.isLoading = false;
          _this5._.msgService.displayErrorMsg(err);
        });
      });
    }
  }, {
    key: 'extractScoresheetScoresAndCreateQAScores',
    value: function extractScoresheetScoresAndCreateQAScores(pdfDetail) {
      var _this6 = this;

      this.isLoading = true;
      return this._.$ngRedux.dispatch((0, _saveTextractData.extractScoresAndCreate)(pdfDetail.feis.id, pdfDetail.textract.id, pdfDetail.adj.id, pdfDetail.event.id, pdfDetail.textract.pdfName, pdfDetail.event.name, undefined, true, true, parseInt(pdfDetail.event.version_id) + 1)).then(function () {
        var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(response) {
          var pdfResponse, uploadededScoresheetEventStatus, displayMessage, _pdfResponse;

          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!response.payload) {
                    _context4.next = 11;
                    break;
                  }

                  _context4.next = 3;
                  return _this6._.$ngRedux.dispatch((0, _getTextractScoresheets.getTextractScoresheetPdfs)(_this6.feis.id, [_textractStatuses.textractStatus.PENDING, _textractStatuses.textractStatus.ERROR]));

                case 3:
                  pdfResponse = _context4.sent;

                  _this6.scorepdfs = pdfResponse.payload;
                  uploadededScoresheetEventStatus = _this6.scorepdfs.find(function (pdf) {
                    return pdf.event.id = response.event_id && pdf.adj.id === response.adj_id && response.feis_id === pdf.feis.id;
                  });
                  displayMessage = 'Textract record uploaded and in QA';

                  if (!uploadededScoresheetEventStatus) {
                    _this6._.msgService.displaySuccessMsg(displayMessage);
                  } else if (uploadededScoresheetEventStatus.event.is_in_qa === 1) {
                    displayMessage = 'The automated score sheet creation process completed with errors or in pending state. Please verify in tabulations page to evaluate if you need to re-upload the score sheet or correct the errors manually.';
                    _this6._.msgService.displaySuccessMsg(displayMessage);
                  } else {
                    _this6._.msgService.displayErrorMsg('Error occurred. Please try again or contact ifeis tech support.');
                  }
                  _this6.isLoading = false;

                  _context4.next = 17;
                  break;

                case 11:
                  _context4.next = 13;
                  return _this6._.$ngRedux.dispatch((0, _getTextractScoresheets.getTextractScoresheetPdfs)(_this6.feis.id, [_textractStatuses.textractStatus.PENDING, _textractStatuses.textractStatus.ERROR]));

                case 13:
                  _pdfResponse = _context4.sent;

                  _this6.scorepdfs = _pdfResponse.payload;
                  _this6.isLoading = false;
                  _this6._.msgService.displayErrorMsg('Error occurred. Please try again or contact ifeis tech support.');

                case 17:
                case 'end':
                  return _context4.stop();
              }
            }
          }, _callee4, _this6);
        }));

        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }()).catch(function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(err) {
          var pdfResponse;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return _this6._.$ngRedux.dispatch((0, _getTextractScoresheets.getTextractScoresheetPdfs)(_this6.feis.id, [_textractStatuses.textractStatus.PENDING, _textractStatuses.textractStatus.ERROR]));

                case 2:
                  pdfResponse = _context5.sent;

                  _this6.scorepdfs = pdfResponse.payload;
                  _this6.isLoading = false;
                  _this6._.msgService.displayErrorMsg(err);

                case 6:
                case 'end':
                  return _context5.stop();
              }
            }
          }, _callee5, _this6);
        }));

        return function (_x3) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }]);

  return TextractController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.textract', ['ui.router', 'ifeis.router-history', _ngFileUpload2.default]).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.textract', {
    url: '/textract',
    template: require('./tpl.html'),
    controller: TextractController,
    controllerAs: 'ctrl',
    ncyBreadcrumb: {
      label: 'Textract',
      parent: 'feiseanna.one.admin.manager'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/textract/index.js
// module id = 585
// module chunks = 0